import React from 'react'
import { Icon } from './People.elements'

type Props = {
  className?: string
}

export const HamburgerMenuIcon = ({ className }: Props) => (
  <Icon
    viewBox="0 0 36 24"
    aria-hidden
    focusable={false}
    role="img"
    className={className}
  >
    <path d="M1.5 2.12357H34.5606" stroke="currentColor" strokeWidth="1.94595" strokeLinecap="square" />
    <path d="M1.5 12H34.5606" stroke="currentColor" strokeWidth="1.94595" strokeLinecap="square" />
    <path d="M1.5 21.8767H34.5606" stroke="currentColor" strokeWidth="1.94595" strokeLinecap="square" />
  </Icon>
)
